module.exports = __webpack_public_path__ + "technology.sb5Hs5D0.svg";